<div class="container">
	@if (fileUploadingInProgress) {
	<mat-progress-bar
		class="progress"
		mode="indeterminate"
	></mat-progress-bar>
	}
	<br />
	<input type="file" multiple name="file" ng2FileSelect [uploader]="uploader" />
	@if (uploadButtonText) {
	<button
		mat-raised-button
		color="primary"
		(click)="uploadFile()"
		class="btn btn-default"
		[disabled]="
			!uploader.getNotUploadedItems().length || fileUploadingInProgress
		"
	>
		{{ uploadButtonText | translate: lang }}
	</button>
	}

	@if (filesList.length > 0) {
	<div class="files-list">
		@for (file of filesList; track file) {
		<div class="file-item">
			<span class="file-name">{{ file.name }}</span>
			<span class="file-size">{{ formatBytes(file.size) }}</span>
			@if (file.validation) {
			<div class="file-validation">
				{{ file.validation }}
			</div>
			}
		</div>
		}
	</div>
	}
</div>
